import { OutOfViewDirections } from '../../hooks/useIsVisibleOnScreen';
import { useContext, useEffect, useState } from 'react';
import { useViewerActions } from '../../hooks/useViewerActions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import getConditionId from '../../utils/getConditionId';
import styled from 'foundations-theming/utils';
import { Button } from 'foundations-components/transitional/components/Button';
import { DownIcon, UpIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScrollToFilterButtonContainer = styled.div.withConfig({
  displayName: "ScrollToFilterButton__ScrollToFilterButtonContainer",
  componentId: "sc-1jwy6kg-0"
})(({
  $direction
}) => ({
  left: '50%',
  position: 'absolute',
  transform: 'translateX(-50%)',
  zIndex: 1000,
  top: $direction === OutOfViewDirections.UP ? '20px' : undefined,
  bottom: $direction === OutOfViewDirections.DOWN ? '20px' : undefined
}));

/* @bend-expect no-styled-foundations-components */
const ScrollButton = styled(Button)(({
  theme
}) => ({
  boxShadow: theme.boxShadow[200]
}));
const ScrollToFilterButton = () => {
  const {
    onHighlightCondition
  } = useViewerActions();
  const {
    draftCondition,
    viewerFilterSelected
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    isFilterVisible = false,
    direction
  } = viewerFilterSelected || {};
  const [hideButton, setHideButton] = useState(true);
  const draftConditionPath = draftCondition && draftCondition.conditionPath;
  const shouldHideButton = !viewerFilterSelected || isFilterVisible || hideButton || !direction;
  useEffect(() => {
    let timeoutId;
    if (!viewerFilterSelected) {
      return;
    }
    if (isFilterVisible) {
      setHideButton(true);
    } else {
      timeoutId = setTimeout(() => {
        setHideButton(false);
      }, 500);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [isFilterVisible, viewerFilterSelected]);
  if (!draftConditionPath || shouldHideButton) {
    return null;
  }
  const onScrollToFilter = () => {
    onHighlightCondition(getConditionId(draftConditionPath));
    setHideButton(true);
  };
  return /*#__PURE__*/_jsx(ScrollToFilterButtonContainer, {
    $direction: direction,
    children: /*#__PURE__*/_jsxs(ScrollButton, {
      onClick: onScrollToFilter,
      size: "sm",
      use: "tertiary",
      children: [direction === OutOfViewDirections.UP ? /*#__PURE__*/_jsx(UpIcon, {}) : /*#__PURE__*/_jsx(DownIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.scrollToSelectedFilterButton.message"
      })]
    })
  });
};
export default ScrollToFilterButton;